import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { postPartidaCategory, updatePartidaCategory } from "../../../api/partidaCategory";
import { alertError, alertSuccess } from "../../../utils/logger";

const CreatePartidaCategoryDialog = ({ open, setOpen, categories, onCreated, categoryToEdit = null }) => {
  const [descripcion, setDescripcion] = useState("");
  const [referencia, setReferencia] = useState("");
  const [parentCategory, setParentCategory] = useState(null);
  const loggedUser = useSelector((store) => store.authentication?.user, shallowEqual);

	const rootCategories = (categories || []).filter(
		(category) => !category.categoria_padre_id && category.id !== categoryToEdit?.id
	);

  useEffect(() => {
    if (open) {
		setDescripcion(categoryToEdit?.descripcion || "");
		setReferencia(categoryToEdit?.referencia || "");
		setParentCategory(
			(categories || []).find((category) => category.id === categoryToEdit?.categoria_padre_id) || null
		);
    }
	}, [open, categoryToEdit, categories]);

  const save = async () => {
    if (!descripcion.trim()) {
      alertError({ error: "La descripción es obligatoria." });
      return;
    }

    try {
		const category = {
			descripcion: descripcion.trim(),
			referencia: referencia.trim() || null,
			categoria_padre_id: parentCategory?.id || null,
		};
		const response = categoryToEdit?.id
			? await updatePartidaCategory(categoryToEdit.id, category, loggedUser?.accessToken)
			: await postPartidaCategory(category, loggedUser?.accessToken);
		if ([200, 201, 204].includes(response.status)) {
        alertSuccess({
          title: "¡Guardada!",
				customMessage: categoryToEdit
					? "Cambios guardados con éxito."
					: parentCategory
            ? "Subcategoría creada con éxito."
            : "Categoría creada con éxito.",
        });
        if (onCreated) {
				onCreated(response.data || { ...category, id: categoryToEdit?.id });
        }
        setOpen(false);
      }
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido crear la categoría." });
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={Boolean(open)} onClose={() => setOpen(false)} className="backdrop">
		<DialogTitle>{categoryToEdit ? "Editar capítulo" : "Nuevo capítulo"}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          required
          label="Descripción"
          value={descripcion}
          onChange={(event) => setDescripcion(event.target.value)}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Referencia"
          value={referencia}
          onChange={(event) => setReferencia(event.target.value)}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
        />
        <Autocomplete
          options={rootCategories}
          getOptionLabel={(option) => option?.descripcion || ""}
          value={parentCategory}
          onChange={(event, value) => setParentCategory(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Categoría padre (opcional)"
              margin="normal"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">Cancelar</Button>
        <Button onClick={save} color="primary" variant="outlined">Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePartidaCategoryDialog;
